module.exports = __webpack_public_path__ + "media/maps/print-81589216.svg";